export default __webpack_public_path__ + "static/media/no_data.5647feff.png";